export const NO_FEE_WEEKEND_POPUP_TEST_IDS = {
    POPUP: "no_fee_weekend_popup",
    CTA_BUTTON: "no_fee_weekend_popup_cta_button",
    CTA_TEXT: "Yay",
};
